<template>
  <div>
    <template v-if="textToScroll.length>+thresholdCharacters">
      <marquee scrolldelay="500" behavior="alternate">
        <slot></slot>
      </marquee>
    </template>
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    textToScroll: {
      required: true,
      default: "0"
    },
    thresholdCharacters: {
      required: true,
      default: 0
    }
  }
};
</script>

<style lang="scss" >
</style>